import React from 'react';
import { useSponsorPopupSchedule } from '../hooks/useSponsorPopupSchedule';

interface SponsorPopupSchedulerProps {
  onReady: () => void;
}

/**
 * Mounted once inside the Router (see App.tsx), never inside a route
 * element, so the sponsor popup's session-wide visible-time clock survives
 * SPA navigation instead of resetting on every page change. Renders nothing
 * itself: App.tsx keeps the lazy import and Suspense boundary for the popup
 * module in its own source, so scripts/verify-performance.js can assert
 * "no static PromoPopup import, one dynamic import" directly against
 * App.tsx's text.
 */
const SponsorPopupScheduler: React.FC<SponsorPopupSchedulerProps> = ({ onReady }) => {
  useSponsorPopupSchedule(onReady);
  return null;
};

export default SponsorPopupScheduler;
